import { buildProviderOptions } from '@flowmuse/models/speech/ui-options';

export function estimateSpeechUsdCost(params: {
  model: any;
  modelId: string;
  nodeData: any;
}) {
  try {
    const { model, modelId, nodeData } = params;
    const provider = (model as any)?.providers?.[0];
    if (!provider || typeof provider.getCost !== 'function') return null;

    const instructions = String(nodeData?.instructions ?? '');
    const characters = instructions.length || undefined;
    const durationSeconds = nodeData?.durationSeconds as number | undefined;
    const providerOptions = buildProviderOptions(modelId, nodeData?.modelUi ?? {});

    const usd = Number(provider.getCost({ characters, durationSeconds, providerOptions }) ?? 0);
    if (!Number.isFinite(usd)) return null;
    return usd;
  } catch {
    return null;
  }
}
